import { render, staticRenderFns } from "./allcandidates.vue?vue&type=template&id=27b4ce9a&lang=html&"
import script from "./allcandidates.vue?vue&type=script&lang=js&"
export * from "./allcandidates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports